export { default } from './StaticPageTextLink';
